module.exports = {
    OKCONSENTS_GET_CONSENTS_FAILURE: 'OKCONSENTS_GET_CONSENTS_FAILURE',
    OKCONSENTS_GET_CONSENTS_REQUEST: 'OKCONSENTS_GET_CONSENTS_REQUEST',
    OKCONSENTS_GET_CONSENTS_SUCCESS: 'OKCONSENTS_GET_CONSENTS_SUCCESS',
    OKCONSENTS_RESET: 'OKCONSENTS_RESET',
    OKCONSENTS_UPDATE_ALL_CONSENTS_STATUS: 'OKCONSENTS_UPDATE_ALL_CONSENTS_STATUS',
    OKCONSENTS_UPDATE_CONSENT_STATUS: 'OKCONSENTS_UPDATE_CONSENT_STATUS',
    OKCONSENTS_UPDATE_CONSENTS_FAILURE: 'OKCONSENTS_UPDATE_CONSENTS_FAILURE',
    OKCONSENTS_UPDATE_CONSENTS_REQUEST: 'OKCONSENTS_UPDATE_CONSENTS_REQUEST',
    OKCONSENTS_UPDATE_CONSENTS_SUCCESS: 'OKCONSENTS_UPDATE_CONSENTS_SUCCESS',
    OKCONSENTS_UPDATE_CHECKBOX_CHANNEL: 'OKCONSENTS_UPDATE_CHECKBOX_CHANNEL',
};
